"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const route_1 = require("@App/navigation/route");
const rightsholder_navigation_1 = __importDefault(require("@App/navigation/rightsholder-navigation"));
const Navigation = {
    home: {
        root: () => '/',
    },
    login: {
        root: () => `/${route_1.LOGIN_ROUTE}`,
        inactive: () => `/${route_1.LOGIN_ROUTE}?inactive`,
        handleInactive: () => `/${route_1.INACTIVE_ROUTE}`,
    },
    signUp: {
        root: () => `/${route_1.SIGN_UP_ROUTE}`,
    },
    signUpComplete: {
        root: () => `/${route_1.SIGN_UP_COMPLETE_ROUTE}`,
    },
    forgotPassword: {
        root: () => `/${route_1.FORGOT_PASSWORD_ROUTE}`,
    },
    createPassword: {
        root: (activatingCode) => `/${route_1.CREATE_PASSWORD_ROUTE}/${activatingCode}`,
    },
    newUser: {
        root: () => `/${route_1.NEW_USER_ROUTE}`,
    },
    search: {
        root: () => `/${route_1.SEARCH_ROUTE}`,
    },
    viewWork: {
        root: (workId) => `/${route_1.VIEW_WORK_ROUTE}/${workId}`,
    },
    contactUs: {
        root: () => `/${route_1.CONTACT_US_ROUTE}`,
    },
    accessDenied: {
        root: () => `/${route_1.ACCESS_DENIED_ROUTE}`,
    },
    ui: {
        root: () => `/${route_1.UI_ROUTE}`,
    },
    recordingDetails: {
        root: (recordingId) => `/${route_1.RECORDING_DETAILS_ROUTE}/${recordingId}`,
    },
    profile: {
        root: () => `/${route_1.PROFILE_ROUTE}`,
        changePassword: () => `/${route_1.PROFILE_ROUTE}/change-password`,
        songwriters: () => `/${route_1.PROFILE_ROUTE}#songwriters'`,
        rightsHolders: () => `/${route_1.PROFILE_ROUTE}#members'`,
        user: () => `/${route_1.PROFILE_ROUTE}#user`,
    },
    registrationRightsholder: {
        root: () => `/${route_1.REGISTRATION_MEMBER_ROUTE}`,
        form: () => `/${route_1.REGISTRATION_MEMBER_ROUTE}/${route_1.FORM_SEGMENT}`,
        questionnaire: () => `/${route_1.REGISTRATION_MEMBER_ROUTE}/${route_1.QUESTIONNAIRE_ROUTE}`,
    },
    registrationSongwriter: {
        root: () => `/${route_1.REGISTRATION_SONGWRITER_ROUTE}`,
    },
    rightholder: rightsholder_navigation_1.default,
    songwriter: {
        root: (id) => `/${route_1.SONGWRITER_ROUTE}/${id}`,
        catalogBuilder: (id) => `/${route_1.SONGWRITER_ROUTE}/${id}/${route_1.SONGWRITER_SUB_ROUTES.link}`,
        myWriters: (id) => `/${route_1.SONGWRITER_ROUTE}/${id}/${route_1.SONGWRITER_SUB_ROUTES.myWriters}`,
        catalog: {
            root: (id) => `/${route_1.SONGWRITER_ROUTE}/${id}/${route_1.SONGWRITER_SUB_ROUTES.catalog.root}`,
            viewWork: (id, workId) => `/${route_1.SONGWRITER_ROUTE}/${id}/${route_1.VIEW_WORK_ROUTE}/${workId}/${route_1.VIEW_ROUTE}`,
        },
        viewSearchedWork: (id, workId) => `/${route_1.SONGWRITER_ROUTE}/${id}/search/work/${workId}/${route_1.VIEW_ROUTE}`,
    },
    notification: {
        preferences: () => `/${route_1.NOTIFICATION_PREFERENCES_ROUTE}`,
    },
};
exports.default = Object.freeze(Navigation);
